import React from "react";
import { useMsal } from "@azure/msal-react";



export const SignOutButton = () => {
    const { instance } = useMsal();

 /*   const handleLogout = (logoutType) => {

            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    */

//<button type="button" className="button" onClick={() => handleLogout("redirect")}>Sign out</button>
 
    return (
    <>
   


    </>
       
       
    )
}